import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import MultiInput from './MultiInput';
import range from 'lodash/range';

const MultiOpenQuestion = props => {
  const { field_type, id, name, number_of_fields, required, pre_text, post_text, validations } = props;
  return (
    <QuestionWrapper {...props}>
      {range(number_of_fields).map(i => (
        <div key={i} className="mb3">
          <span className='mr2'>{pre_text}</span>
          <MultiInput
            className="mb0"
            field_type={field_type}
            index={i}
            name={`questions[${name}][]`}
            questionId={id}
            required={required}
            validations={validations}
            disableCopyPaste={props.survey?.disable_copy_paste}
          />
          <span className='ml2'>{post_text}</span>
        </div>
      ))}
    </QuestionWrapper>
  );
};

MultiOpenQuestion.propTypes = {
  field_type: PropTypes.oneOf([
    'date',
    'datetime',
    'email',
    'essay',
    'phone',
    'text',
    'time',
    'url',
    'zipcode_us',
    'numeric'
  ]).isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  number_of_fields: PropTypes.number,
  required: PropTypes.bool,
  validations: PropTypes.object,
  text: PropTypes.string,
  temp_response_attachment_keys: PropTypes.array,
  disableCopyPaste: PropTypes.bool
};

MultiOpenQuestion.defaultProps = {
  field_type: 'text',
  number_of_fields: 1,
};

export default MultiOpenQuestion;
